import React from 'react';
import AccountCard from 'Components/Accounts/AccountCard';
import {
  FDBox, FDPaper, FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

const getAccountProps = (account) => {
  const accountProps = {
    accountName: account.attr?.('title') ?? account.title,
    iconSrc: account.attr?.('image') ?? account.image,
    maskedAccountNumber: account.attr?.('subtitle') ?? account.subtitle,
    balance: account.attr?.('balance') ?? account.balance,
  };

  return accountProps;
};

const AccountACHTransferAccountSummaryCard = ({
  isWithdrawal = false,
  fromAccount,
  toAccount,
}) => {
  const fromAccountProps = getAccountProps(fromAccount);
  const toAccountProps = getAccountProps(toAccount);

  return (
    <FDPaper width={'100%'} padding={500}>
      <FDStack direction={'column'} alignItems={'center'} spacing={2} justifyContent="flex-start">
        <FDBox width={'100%'}><FDTitleText align="start" color="textPrimary" size="sm" value={'Withdraw from:'} /></FDBox>
        <AccountCard
          labelColor={isWithdrawal ? 'primary' : 'primaryGray'}
          {...fromAccountProps}
        />
        <FDBox width={'100%'}><FDTitleText align="start" size="sm" color="textPrimary" value={'Transfer to:'} /></FDBox>
        <AccountCard
          {...toAccountProps}
        />
      </FDStack>
    </FDPaper>
  );
};

AccountACHTransferAccountSummaryCard.propTypes = {
  isWithdrawal: PropTypes.bool,
  fromAccount: PropTypes.object.isRequired,
  toAccount: PropTypes.object.isRequired,
};

export { AccountACHTransferAccountSummaryCard };
